// LiquorLicenseRegistration.jsx
import React from "react";

export default function LiquorLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Liquor License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Liquor License Registration Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in obtaining Liquor Licenses in
            accordance with state excise laws and regulations, helping bars,
            restaurants, clubs, and retail outlets align with applicable
            licensing conditions.
          </p>
          <p className="text-gray-700">
            From choosing the appropriate category of license and preparing
            application details to coordinating with excise authorities, the
            process is handled in a structured manner so your premises and
            operations meet state requirements.
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/260922/pexels-photo-260922.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Restaurant bar counter symbolising liquor licensing"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Liquor License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists applicants in compiling the key
              proofs and details commonly required by state excise departments
              for liquor licensing.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Identity and address proof of the applicant or authorized
                  signatory (such as Aadhaar, passport, voter ID, or driving
                  licence, along with a recent address proof).[web:193][web:197]
                </li>
                <li>
                  Premises ownership or lease documents together with relevant
                  municipal records or recent utility bills to establish lawful
                  possession.[web:193][web:194]
                </li>
                <li>
                  Business registration certificate (incorporation certificate,
                  partnership deed, or other registration appropriate to the
                  business form).[web:197]
                </li>
                <li>
                  Site layout or floor plan indicating service or sale areas,
                  storage spaces, entry/exit points, and overall shop/venue
                  configuration, as generally expected by excise authorities.[web:194][web:195]
                </li>
                <li>
                  Any additional clearances or NOCs prescribed by the state
                  (such as fire or local-body NOCs), depending on the specific
                  state policy and license category.[web:193][web:197]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm combines understanding of state excise frameworks with
              practical documentation and process handling to help liquor
              businesses proceed with clarity and reduced procedural friction.[web:196][web:197]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Knowledge of State Excise Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on applicable state excise rules, license categories,
                  and key operational conditions such as age limits, location
                  restrictions, and record-keeping expectations.[web:193][web:197]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Transparent Application Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Clear outlining of steps, timelines, and information
                  requirements, helping applicants understand how their
                  application will move from submission to scrutiny and
                  approval.[web:193][web:196]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Regulatory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional assistance across documentation, clarification
                  responses, and renewal-related follow-up, supporting ongoing
                  alignment with liquor license conditions.[web:196][web:197]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
